module.exports = __webpack_public_path__ + "static/media/solvid.a1cfbbcb.mp4";